import CoconeuseBioTemplate from "../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseHeather = () => (
  <CoconeuseBioTemplate
    name="Heather"
    subtitle="Gardienne du lien entre Ciel et Terre"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/koq18pg1_Copy%20of%20DSC01853.jpg"
    bioText={[
      "Bienvenue à toi, douce âme.",
      "Je suis heureuse de te rencontrer et de partager avec toi ma médecine.",
      "Ma présence ouvre un espace de soutien, de douceur et de reconnexion, quel que soit l'endroit où tu te trouves sur ton chemin.",
      "Un espace où le ciel et la terre peuvent à nouveau se rejoindre en toi.",
      "Ma médecine se décline en plusieurs formes : les cérémonies du cacao, le Zhineng Qigong, la médecine traditionnelle chinoise et la nutrition, les méditations guidées, les soins du corps et de l'énergie.",
      "Ma pratique allie la Terre et le Ciel, la science et la spiritualité, avec le cœur comme boussole, comme ancrage et comme lumière sacrée.",
    ]}
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/dnjker6v_DSC07687.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/2fsrk4ia_DSC06304.jpg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/fhepxr4y_Copy%20of%20DSC02694.jpg",
    ]}
    expertise={["Énergie subtile", "Connexion Terre · Ciel", "Présence vibratoire"]}
  />
);

export default CoconeuseHeather;
